var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2455_450)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.4441 31.9075H7.55542C5.73657 31.9075 4.26172 30.4329 4.26172 28.6138V14.137L15.9997 3.58497L27.7378 14.137V28.6138C27.7378 30.4329 26.2632 31.9075 24.4441 31.9075Z",
    fill: "#FCE182"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9997 3.58497L4.26172 14.137V28.6138C4.26172 30.4329 5.73657 31.9075 7.55542 31.9075H14.3994V17.1606C14.3994 14.98 15.2576 12.887 16.7886 11.334L19.0395 9.0503V6.31764L15.9997 3.58497Z",
    fill: "#E2CA75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6973 16.8955L16 6.29566L4.303 16.8955C3.24929 17.8503 1.6216 17.7703 0.666771 16.7168C-0.288062 15.6631 -0.20774 14.0352 0.845726 13.0806L12.5735 2.45265C14.5269 0.682385 17.4732 0.682385 19.4268 2.45289L31.1543 13.0806C32.2078 14.0352 32.2878 15.6631 31.3333 16.7168C30.8252 17.2773 29.1543 18.0918 27.6973 16.8955Z",
    fill: "#FF929F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.406 19.4121H13.594C12.2461 19.4121 11.1533 20.5049 11.1533 21.8528V31.9075H20.8467V21.8528C20.8467 20.5049 19.7539 19.4121 18.406 19.4121Z",
    fill: "#BD8A65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3997 19.4121H13.594C12.2461 19.4121 11.1533 20.5049 11.1533 21.8528V31.9075H14.3997V19.4121Z",
    fill: "#A67958"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.23527 12.2356C4.11394 10.678 5.31242 9.03272 5.31242 9.03272L0.845629 13.0806C-0.207837 14.0352 -0.287915 15.6631 0.666674 16.7168C1.62151 17.7703 3.24919 17.8503 4.3029 16.8955L8.39445 13.1877C8.39445 13.1877 6.35685 13.7932 5.23527 12.2356Z",
    fill: "#FF737D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2455_450"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.f094e63f73b1fa705460b7fd7fb82d47.svg";
export { ForwardRef as ReactComponent };